/**
 * Tema y marca.
 *
 * Dos cosas que el estandar exige y que no son CSS puro:
 *
 *   * El tema se conmuta con data-theme en <html> y SE PERSISTE. Hay dos
 *     controles: el boton de la topbar y el switch al pie de la sidebar.
 *   * --brand y --brand-2 se INYECTAN desde la configuracion, no se escriben
 *     en el CSS, para que la plataforma se vista con la marca del cliente sin
 *     tocar una hoja de estilos.
 */

export type Tema = 'light' | 'dark';

const LLAVE_TEMA = 'scm_tema';

/* Marca de Enteratek. Cuando el tablero de un cliente use la suya, estos dos
   valores salen de su configuracion, no de aqui. */
export const MARCA_ENTERATEK = { brand: '#00b3a4', brand2: '#0ea5e9' };

/**
 * localStorage siempre con respaldo en memoria: en una ventana privada o con
 * los datos del sitio bloqueados, el acceso LANZA, y una excepcion al leer el
 * tema no puede tumbar la aplicacion.
 */
const memoria: Record<string, string> = {};

export const almacen = {
  leer(llave: string): string | null {
    try {
      return localStorage.getItem(llave) ?? memoria[llave] ?? null;
    } catch {
      return memoria[llave] ?? null;
    }
  },
  guardar(llave: string, valor: string): void {
    memoria[llave] = valor;
    try {
      localStorage.setItem(llave, valor);
    } catch {
      /* Queda en memoria y la sesion sigue funcionando. */
    }
  },
};

export function temaGuardado(): Tema {
  const guardado = almacen.leer(LLAVE_TEMA);
  if (guardado === 'light' || guardado === 'dark') return guardado;
  /* Sin preferencia guardada, se respeta la del sistema. */
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function aplicarTema(tema: Tema): void {
  document.documentElement.setAttribute('data-theme', tema);
  almacen.guardar(LLAVE_TEMA, tema);
}

export function aplicarMarca(brand: string, brand2: string): void {
  const raiz = document.documentElement;
  raiz.style.setProperty('--brand', brand);
  raiz.style.setProperty('--brand-2', brand2);
}
